import React from "react"
import listData from "../data/lists.json"

export default function List({ id, listType }) {
  const data = listData.find(obj => {
    return obj.id === id
  })
  return (
    <section className="list">
      <header>
        <h3 className="title--tertiary title--uppercase">{data.title}</h3>
        {data.subtitle ? (
          <span className="title--meta title--uppercase">{data.subtitle}</span>
        ) : null}
      </header>
      <ul className={listType === "ol" ? "list--ordered" : null}>
        {data.list.map((item, index) => {
          return <li key={`listItem-${index}`}>{item}</li>
        })}
      </ul>
    </section>
  )
}
